export const waitForContent = (
  selector: string,
  onContentVisible?: (elements: HTMLElement[]) => void,
  container?: HTMLElement
) => {
  const selectedElements: HTMLElement[] = Array.from(
    (container || document).querySelectorAll(selector)
  );

  // Check if we have the elements AND they're actually visible in viewport
  const hasVisibleFields = selectedElements.some((element) => {
    const rect = element.getBoundingClientRect();
    const isHostVisible =
      rect.width > 0 &&
      rect.height > 0 &&
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= window.innerHeight &&
      rect.right <= window.innerWidth;

    // If host is visible, also check if shadow root content is rendered
    if (isHostVisible && element.shadowRoot) {
      const shadowContent = element.shadowRoot.querySelector('*');
      if (shadowContent) {
        const shadowRect = shadowContent.getBoundingClientRect();
        return shadowRect.width > 0 && shadowRect.height > 0;
      }
      return false; // Shadow root exists but no content yet
    }

    return isHostVisible;
  });

  if (hasVisibleFields) {
    return onContentVisible?.(selectedElements);
  } else {
    // Check again next frame - pass the selector and callback
    requestAnimationFrame(() =>
      waitForContent(selector, onContentVisible, container)
    );
  }
};

export const waitForShadowContent = (
  hostSelector: string,
  shadowSelector: string,
  onContentVisible?: (shadowElements: Element[]) => void,
  container?: HTMLElement
) => {
  const hostElements: HTMLElement[] = Array.from(
    (container || document).querySelectorAll(hostSelector)
  );

  const shadowElements: Element[] = [];

  // Collect all matching elements from shadow roots
  hostElements.forEach((host) => {
    if (host.shadowRoot) {
      const elements = Array.from(
        host.shadowRoot.querySelectorAll(shadowSelector)
      );
      shadowElements.push(...elements);
    }
  });

  // Check if shadow content is visible
  const hasVisibleShadowContent = shadowElements.some((element) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= window.innerHeight &&
      rect.right <= window.innerWidth
    );
  });

  if (hasVisibleShadowContent && shadowElements.length > 0) {
    return onContentVisible?.(shadowElements);
  } else {
    requestAnimationFrame(() =>
      waitForShadowContent(
        hostSelector,
        shadowSelector,
        onContentVisible,
        container
      )
    );
  }
};

export const stripPofMargins = (container?: HTMLElement) => {
  function removeMargins(shadowElements: Element[]) {
    shadowElements.forEach((p) => {
      if (p instanceof HTMLElement) {
        p.style.marginTop = '0';
        p.style.marginBottom = '0';
      }
    });
  }
  waitForShadowContent('goa-text', 'p', removeMargins, container);
};
